class SendMessageResult {

    SessionId: number;
    Messages: string[];

    constructor(sessionId: number, messages: string[]) {
        this.SessionId = sessionId;
        this.Messages = messages;
    }
}

export default SendMessageResult;
